import axios from "axios";

const adminClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/admin`
    : "http://localhost:5000/api/admin",
});

// Automatically attach the admin token to every request
adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default adminClient;
